import React from 'react';
import './Pagination.scss';

const Pagination = ({ 
    currentPage = 1, 
    totalPages = 1, 
    hasNext = false, 
    hasPrev = false,
    onPageChange,
    isLoading = false 
}) => {
    // Don't show pagination if only one page or no pages
    if (totalPages <= 1) {
        return null;
    }

    const handlePageChange = (page) => {
        if (page !== currentPage && !isLoading && onPageChange) {
            onPageChange(page);
        }
    };

    const handlePrev = () => {
        if (hasPrev && currentPage > 1) {
            handlePageChange(currentPage - 1);
        }
    };

    const handleNext = () => {
        if (hasNext && currentPage < totalPages) {
            handlePageChange(currentPage + 1);
        }
    };

    // Generate page numbers to display
    const getPageNumbers = () => {
        const pages = [];
        const maxVisible = 5;
        
        if (totalPages <= maxVisible) {
            // Show all pages if total is less than max visible
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            // Show first page
            pages.push(1);
            
            if (currentPage > 3) {
                pages.push('...');
            }
            
            // Show pages around current page
            const start = Math.max(2, currentPage - 1);
            const end = Math.min(totalPages - 1, currentPage + 1);
            
            for (let i = start; i <= end; i++) {
                pages.push(i);
            }
            
            if (currentPage < totalPages - 2) {
                pages.push('...');
            }
            
            // Show last page
            pages.push(totalPages);
        }
        
        return pages;
    };

    const pageNumbers = getPageNumbers();

    return (
        <div className="octopus-pagination">
            <button
                className="octopus-pagination-btn octopus-pagination-prev"
                onClick={handlePrev}
                disabled={!hasPrev || isLoading || currentPage === 1}
                aria-label="Previous page"
            >
                <i className="fa-solid fa-chevron-left"></i>
                Previous
            </button>
            
            <div className="octopus-pagination-pages">
                {pageNumbers.map((page, index) => {
                    if (page === '...') {
                        return (
                            <span key={`ellipsis-${index}`} className="octopus-pagination-ellipsis">
                                ...
                            </span>
                        );
                    }
                    
                    return (
                        <button
                            key={page}
                            className={`octopus-pagination-page ${currentPage === page ? 'active' : ''}`}
                            onClick={() => handlePageChange(page)}
                            disabled={isLoading}
                            aria-label={`Go to page ${page}`}
                            aria-current={currentPage === page ? 'page' : null}
                        >
                            {page}
                        </button>
                    );
                })}
            </div>
            
            <button
                className="octopus-pagination-btn octopus-pagination-next"
                onClick={handleNext}
                disabled={!hasNext || isLoading || currentPage === totalPages}
                aria-label="Next page"
            >
                Next
                <i className="fa-solid fa-chevron-right"></i>
            </button>
        </div>
    );
};

export default Pagination;

